import { render, staticRenderFns } from "./ExportFaqModal.vue?vue&type=template&id=ffbb6dac&scoped=true&"
import script from "./ExportFaqModal.vue?vue&type=script&lang=js&"
export * from "./ExportFaqModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportFaqModal.vue?vue&type=style&index=0&id=ffbb6dac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb6dac",
  null
  
)

export default component.exports